import { AuthGuard } from "./core/service/auth/auth.guard";
import { SessionGuard } from "./core/service/auth/session.guard";
import { MapGuard } from "./core/service/auth/map.guard";
import { QuestionComponent } from "./features/question/question.component";
import { NgModule } from "@angular/core";
import { Routes, RouterModule } from "@angular/router";
import { GlobalClassroomComponent } from "./features/global-classroom/global-classroom.component";
import { LoginComponent } from "./core/component/login/login.component";
import { VideoListComponent } from "./core/component/video-list/video-list.component";
import { MapViewComponent } from "./features/map-view/map-view.component";
import { BadgeEarnedComponent } from "./features/component/badge-earned/badge-earned.component";
import { TopicCompletedComponent } from "./features/component/topic-completed/topic-completed.component";
import { CategoryComponent } from "./features/teacher/category/category.component";
import { InstructionsComponent } from "./features/teacher/instructions/instructions.component";
import { JoinTeamComponent } from "./features/teacher/join-team/join-team.component";
import { LeaderboardComponent } from "./features/teacher/leaderboard/leaderboard.component";
import { QuizCompletedComponent } from "./features/teacher/quiz-completed/quiz-completed.component";
import { LobyComponent } from "./features/student/loby/loby.component";
import { QuizBeginComponent } from "./features/student/quiz-begin/quiz-begin.component";
import { QuizComponent } from "./features/student/quiz/quiz.component";
import { QuizFinishedComponent } from "./features/student/quiz-finished/quiz-finished.component";
import { ResultComponent } from './features/teacher/result/result.component';

const routes: Routes = [
  { path: "", redirectTo: "login", pathMatch: "full" },
  // { path: 'home', component: GlobalClassroomComponent },
  { path: "login", component: LoginComponent, canActivate: [SessionGuard] },
  { path: "map-view", component: MapViewComponent, canActivate: [MapGuard] },
  { path: "list-view", component: VideoListComponent },
  {
    path: "badge-earned",
    component: BadgeEarnedComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "topic-completed",
    component: TopicCompletedComponent,
    canActivate: [AuthGuard],
  },
  // { path: 'template', loadChildren: () => import('./features/template/template.module').then(m => m.TemplateModule) },
  { path: "question", component: QuestionComponent, canActivate: [AuthGuard] },
  // Teacher team routes
  { path: "category", component: CategoryComponent, canActivate: [AuthGuard] },
  {
    path: "instructions",
    component: InstructionsComponent,
    canActivate: [AuthGuard],
  },
  { path: "join-team", component: JoinTeamComponent, canActivate: [AuthGuard] },
  {
    path: "leaderboard",
    component: LeaderboardComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "quiz-completed",
    component: QuizCompletedComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "result",
    component: ResultComponent,
    canActivate: [AuthGuard],
  },
  // Student team-play routes
  { path: "loby", component: LobyComponent },
  { path: "quiz-begin", component: QuizBeginComponent },
  { path: "quiz", component: QuizComponent },
  { path: "quiz-finished", component: QuizFinishedComponent },
];

@NgModule({
  // imports: [RouterModule.forRoot(routes)],
  // exports: [RouterModule]
  imports: [RouterModule.forRoot(routes, { onSameUrlNavigation: "reload" })],
  exports: [RouterModule],
})
export class AppRoutingModule {}
